<template>
  <div class="sk-chasing-dots" v-if="show">
    <div class="sk-child sk-dot1"></div>
    <div class="sk-child sk-dot2"></div>
  </div>
</template>
<script>
  export default {
    'name': 'chasing-dots',
    'props': ['show']
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../assets/scss/variables";

  .sk-chasing-dots {
    margin: 0 auto;
    width: .5rem;
    height: .5rem;
    position: relative;
    text-align: center;
    -webkit-animation: sk-chasingDotsRotate 2s infinite linear;
    animation: sk-chasingDotsRotate 2s infinite linear;
  }

  .sk-chasing-dots .sk-child {
    width: 60%;
    height: 60%;
    display: inline-block;
    position: absolute;
    top: 0;
    background-color: $base-blue;
    border-radius: 100%;
    -webkit-animation: sk-chasingDotsBounce 2s infinite ease-in-out;
    animation: sk-chasingDotsBounce 2s infinite ease-in-out;
  }

  .sk-chasing-dots .sk-dot2 {
    top: auto;
    bottom: 0;
    -webkit-animation-delay: -1s;
    animation-delay: -1s;
  }

  @-webkit-keyframes sk-chasingDotsRotate {
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  @keyframes sk-chasingDotsRotate {
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  @-webkit-keyframes sk-chasingDotsBounce {
    0%, 100% {
      -webkit-transform: scale(0);
      transform: scale(0);
    }
    50% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }

  @keyframes sk-chasingDotsBounce {
    0%, 100% {
      -webkit-transform: scale(0);
      transform: scale(0);
    }
    50% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }
</style>



// WEBPACK FOOTER //
// Spinner.vue?60f84404